import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { stringify } from 'flatted';
import { GrupoUsuarioService } from 'src/services/grupo-usuario.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { UsuarioService } from 'src/services/usuario.service';
import { parse } from 'flatted';
import { MessageService, TreeTableNode } from 'primeng/api';

@Component({
    selector: 'app-permissoes',
    templateUrl: './permissoes.component.html',
    styleUrls: ['./permissoes.component.css'],
    standalone: false
})
export class PermissoesComponent implements OnInit, AfterViewInit {

  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  /** Altura fixa para o corpo da TreeTable (tbody) – baseada na viewport para o scroll funcionar */
  scrollHeight: string = 'calc(100vh - 280px)';

  cols = [
    { field: 'name', header: 'Nome' },
  ];

  selectedDireitos: TreeTableNode[] | TreeTableNode | null = [];

  dataSource:any[] = [];

  grupoList = [];

  selectedGrupo;

  constructor(
    protected permissoesService: PermissoesService,
    private grupoService: GrupoUsuarioService,
    private messageService: MessageService,
  ) { }

  ngOnInit() {
    this.permissoesService.getPermissoes().subscribe(json => {
      this.dataSource = json;
    });
    this.listAllGrupos();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.calculateScrollHeight(), 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper?.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = Math.max(wrapperHeight - 20, 300);
      this.scrollHeight = `${calculatedHeight}px`;
    }
  }

  changeGrupo() {
    if (this.selectedGrupo) {
      this.permissoesService.findByGrupo(this.selectedGrupo.id).subscribe(json => {
        this.selectedDireitos = json ? parse(json) : [];
        this.permissoesService.getPermissoes().subscribe(fullJson => {
          this.dataSource = fullJson;
        });
      });
      setTimeout(() => this.calculateScrollHeight(), 300);
    }
  }

  listAllGrupos() {
    this.grupoList = []
    this.grupoService.index().subscribe(json => {
     this.grupoList = json.filter(x => x.ativo == true)
    })
  }




  save() {
    if (!this.selectedGrupo) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione um grupo antes de salvar.' });
      return;
    }

    let body = {
      grupo: this.selectedGrupo,
      direitos: stringify(this.selectedDireitos)
    }

    this.permissoesService.save(body, null).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Permissões salvas com sucesso!' });
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao salvar permissões. Tente novamente.' });
        console.error('Erro ao salvar permissões:', err);
      }
    });
  }

}
